import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isMemberSession, getMemberAuth } from "../../api/memberPortalClient";

/**
 * Ensures the current session is a member portal session (JWT).
 * Unauthenticated users are sent to the shared /login page.
 */
function MemberPortalGuard({ children }) {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (isMemberSession()) {
      setReady(true);
      return;
    }

    const sessionStr = sessionStorage.getItem("user-info");
    if (sessionStr) {
      try {
        const session = JSON.parse(sessionStr);
        const roleKey = String(session?.user?.role || "").toLowerCase();
        if (roleKey === "user" || roleKey === "member") {
          navigate("/login", {
            replace: true,
            state: {
              message:
                "Please sign in again to access your member portal.",
            },
          });
          return;
        }
      } catch {
        // fall through
      }
      navigate("/dashboard", { replace: true });
      return;
    }

    if (!getMemberAuth()) {
      navigate("/login", { replace: true });
      return;
    }

    navigate("/login", { replace: true });
  }, [navigate]);

  if (!ready) {
    return (
      <div className="flex items-center justify-center min-h-[40vh] text-gx-ink-soft">
        Loading…
      </div>
    );
  }

  return children;
}

export default MemberPortalGuard;
